import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'vex-popup-modal',
  templateUrl: './popup-modal.component.html',
  styleUrls: ['./popup-modal.component.scss']
})
export class PopupModalComponent implements OnInit {
  @Input() icon: string;
  @Input() iconClass: string;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() redirectUrl: string;
  @Input() closeBtnTop: boolean = false;
  @Input() callbackBtn: string;
  @Input() buttonTitle: string;
  @Input() plan: any;
  @Input() date: any;
  @Input() showPortalLink: boolean = false;
  @ViewChild('planDescriptionHTML') htmlContentRef!: ElementRef;
  @Input() customHtml: any;


  constructor(private dialogRef: MatDialogRef<any>, private router: Router, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.icon = data?.icon;
    this.iconClass = data?.iconClass;
    this.title = data?.title;
    this.subTitle = data?.subTitle;
    this.redirectUrl = data?.redirectUrl;
    this.closeBtnTop = data?.closeBtnTop;
    this.callbackBtn = data?.callbackBtn;
    this.buttonTitle = data?.buttonTitle;
    this.plan = data?.plan;
    this.date = data?.date;
    this.showPortalLink = data?.showPortalLink;
    this.customHtml = data?.customHtml;
  }

  ngOnInit() {
  }

  closeModal(ctx?: string) {
    this.dialogRef.close({callback: ctx});  // Chiude la modal
    if(this.redirectUrl){
      this.router.navigate([this.redirectUrl]);
    }
  }

  ngAfterViewInit() {
    if(this.plan){
      const el = this.htmlContentRef.nativeElement;
      el.innerHTML = el.innerHTML.replace(/•/g, `<ion-icon name="checkmark-circle" style="color: #db3687; font-size: 1.4em; vertical-align: middle; margin-right: 6px;"></ion-icon>`);
    }
  }

}
